/**
 * Confirmação curta no prontuário — paciente já conhecido, sem wizard de agenda.
 */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface EvolutionConfirmDialogProps {
  open: boolean;
  patientDisplay?: string;
  professionalDisplay?: string;
  hasOpenEvolution?: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function EvolutionConfirmDialog({
  open,
  patientDisplay,
  professionalDisplay,
  hasOpenEvolution = false,
  loading = false,
  onClose,
  onConfirm,
}: EvolutionConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {hasOpenEvolution ? "Continuar evolução" : "Evoluir paciente"}
      </DialogTitle>
      <DialogContent dividers>
        {patientDisplay && (
          <Typography variant="body1" fontWeight={600}>
            Paciente: {patientDisplay}
          </Typography>
        )}
        {professionalDisplay && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Profissional: {professionalDisplay}
          </Typography>
        )}
        <Typography variant="body2" sx={{ mt: 2 }}>
          {hasOpenEvolution
            ? "Há uma evolução em aberto. Você continuará o atendimento sem criar outro agendamento."
            : "Será criada uma evolução sem custo e o atendimento será iniciado agora."}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading} sx={{ textTransform: "none" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onConfirm}
          disabled={loading}
          sx={{ textTransform: "none", fontWeight: 700 }}
        >
          {loading ? "Iniciando..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
